// tslint:disable:max-line-length

import React from 'react';

export const StatusSuccess = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM7,11.41,3.59,8,5,6.59l2,2,4-4L12.41,6Z" />
    </svg>
  );
};
